import { cn } from "@magicweave/design";

/**
 * What the lamp is doing, in the five things it can show: it breathes while it watches ("idle"),
 * glows with a rising wisp when Djinn has something for you ("has"), turns while a fix runs
 * ("working"), greys when Djinn cannot think or is paused ("paused"), and is still while the dock
 * is open, because the genie is out ("out").
 */
export type LampLook = "idle" | "has" | "working" | "paused" | "out";

/** Where the spout is in the mark's 24-unit box: the light leaves, and returns, here. */
export const SPOUT = { x: 20.5, y: 9.6, box: 24 } as const;

/**
 * The original lamp mark: body, spout, handle curl, lid and foot, with the steam wisp that
 * drifts from the spout and three smoke motes behind it. The DS `Icon lamp` stays the plain
 * 16 px fallback (the rail's row); this is the mark for Djinn's own entries. The mark itself is
 * drawn in `currentColor`, so it keeps the ink the button gives it in either theme.
 */
export function LampMark({
  look = "idle",
  className,
}: {
  look?: LampLook;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn("dj-lamp", className)}
      data-lamp={look}
      data-djinn-lamp=""
    >
      <span className="dj-g" />
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 13.5h12.5c0 2.2-2.6 3.8-6.2 3.8S3 15.7 3 13.5Z" />
        <path d="M15.5 13.5 20.5 10" />
        <path d="M3 13.5c-1.1-.4-1.7-1.3-1.5-2.3.2-.9 1-1.5 2-1.4" />
        <path d="M6.8 13.5c0-1.7 1.1-3 2.5-3s2.5 1.3 2.5 3" />
        <path d="M9.3 17.3v2.4M7 20.2h4.6" />
        <path className="dj-wisp" d="M20.5 10c.9-1.4-.4-2.5.3-4 .5-1.1 1.4-1.6 1.1-3.3" />
      </svg>
      <i className="dj-smoke" />
      <i className="dj-smoke" />
      <i className="dj-smoke" />
      <span className="dj-ring" />
    </span>
  );
}
